<template>
  <div class="card-full" v-loading="loading" style="box-sizing: border-box;">
    <div class="notice-content">
        <div v-if="appendList && appendList.length" style="display: flex">
          <div>采购报告附件:</div>
          <div class="filelist">
            <div
              v-for="(item, index) in appendList"
              :key="index"
              class="fileitem"
            >
              <div class="name" @click="downFile(item.appendurl)">
                <a :src="uploadAddr + item.appendurl">{{
                  item.appendfilename
                }}</a>
              </div>
            </div>
          </div>
        </div>
      <div class="notice-header">
        <h2 class="title-A">{{ project.projectname }}的{{ CGname }}报告</h2>
        <div class="line-A"></div>
        <div class="line-A"></div>
      </div>
      <div class="content">
        <div class="line-A"></div>
        <div v-html="project.projectjjcontent" class="content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import common from "@/mixin/common";

export default {
  name: "projectReportFile",
  mixins: [common],
  filters: {},
  computed: {
    uploadAddr() {
      return this.$store.getters.uploadAddr;
    },
    CGname() {
      if (this.project.prsflg == "2") {
        return "评标";
      } else if (this.project.prsflg == "1" || this.project.prsflg == "3") {
        return "竞价";
      } else if (this.project.prsflg == "4" || this.project.prsflg == "5") {
        return "竞拍";
      }
    },
  },
  data() {
    return {
      project: {},
      appendList: [],
      btnLoading: false,
      loading: false,
    };
  },
  created() {},
  deactivated() {
    this.$destroy();
  },
  async activated() {
    await this.getModel();
  },
  mounted() {
    this.getModel();
  },
  components: {},
  methods: {
    async getModel() {
      this.loading = true;
      let res = await request({
        method: "get",
        url: "/xmgl/project/getProjectById",
        params: { projectid: this.$route.query.projectid },
      });
      this.project = res[0];
      await this.getAppendList();
      this.loading = false;
    },
    init() {
      this.appendList = [];
    },
    async getAppendList() {
      let res = await request({
        method: "get",
        url: "/ywgl/append/getAppendListByFromId",
        params: {
          appendfromid: this.$route.query.projectid,
          appendfromtype: 20,
        },
      });
      this.appendList = res;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../styles/table.scss";
@import "../../styles/filelist";
.card-full {
  display: flex;
  height: 100%;
  width: 100%;
  padding: 10px;
}
.notice-content {
  width: 100%;
}
.notice-header {
  flex: 0 0 30px;
}
.opinion {
  font-size: 14px;
  margin-top: -8px;
  color: #606266;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC,
    Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial,
    sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
}
.title-A {
  color: #000;
  display: flex;
  flex-direction: column;
  text-align: center;
  font-weight: bold;
}
.content {
  width: 100%;
  flex: 1;
}
.line-A {
  width: 100%;
  background: #000;
  height: 1px;
  margin-bottom: 1px;
}
.field {
  text-align: left;
  font-size: 16px;
}
.file {
  color: #2f74ff;
  cursor: pointer;
}
</style>
